import _toConsumableArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.promise.finally.js";
import _regeneratorRuntime from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { equals, flatten, isNonEmptyArray, mergeSort, coalesce } from '../../../base/common/arrays.js';
import { CancellationToken } from '../../../base/common/cancellation.js';
import { illegalArgument, isPromiseCanceledError, onUnexpectedExternalError } from '../../../base/common/errors.js';
import { Disposable, DisposableStore } from '../../../base/common/lifecycle.js';
import { URI } from '../../../base/common/uri.js';
import { TextModelCancellationTokenSource } from '../../browser/core/editorState.js';
import { registerLanguageCommand } from '../../browser/editorExtensions.js';
import { Range } from '../../common/core/range.js';
import { Selection } from '../../common/core/selection.js';
import * as modes from '../../common/modes.js';
import { IModelService } from '../../common/services/modelService.js';
import { CodeActionKind, filtersAction, mayIncludeActionsOfKind } from './types.js';
import { Progress } from '../../../platform/progress/common/progress.js';
export var codeActionCommandId = 'editor.action.codeAction';
export var refactorCommandId = 'editor.action.refactor';
export var sourceActionCommandId = 'editor.action.sourceAction';
export var organizeImportsCommandId = 'editor.action.organizeImports';
export var fixAllCommandId = 'editor.action.fixAll';

var ManagedCodeActionSet = /*#__PURE__*/function (_Disposable) {
  _inherits(ManagedCodeActionSet, _Disposable);

  var _super = _createSuper(ManagedCodeActionSet);

  function ManagedCodeActionSet(actions, documentation, disposables) {
    var _this;

    _classCallCheck(this, ManagedCodeActionSet);

    _this = _super.call(this);
    _this.documentation = documentation;

    _this._register(disposables);

    _this.allActions = mergeSort(_toConsumableArray(actions), ManagedCodeActionSet.codeActionsComparator);
    _this.validActions = _this.allActions.filter(function (action) {
      return !action.disabled;
    });
    return _this;
  }

  _createClass(ManagedCodeActionSet, [{
    key: "hasAutoFix",
    get: function get() {
      return this.validActions.some(function (fix) {
        return !!fix.kind && CodeActionKind.QuickFix.contains(new CodeActionKind(fix.kind)) && !!fix.isPreferred;
      });
    }
  }], [{
    key: "codeActionsComparator",
    value: function codeActionsComparator(a, b) {
      if (a.isPreferred && !b.isPreferred) {
        return -1;
      } else if (!a.isPreferred && b.isPreferred) {
        return 1;
      }

      if (isNonEmptyArray(a.diagnostics)) {
        if (isNonEmptyArray(b.diagnostics)) {
          return a.diagnostics[0].message.localeCompare(b.diagnostics[0].message);
        } else {
          return -1;
        }
      } else if (isNonEmptyArray(b.diagnostics)) {
        return 1;
      } else {
        return 0; // both have no diagnostics
      }
    }
  }]);

  return ManagedCodeActionSet;
}(Disposable);

var emptyCodeActionsResponse = {
  actions: [],
  documentation: undefined
};
export function getCodeActions(model, rangeOrSelection, trigger, progress, token) {
  var _this2 = this;

  var _a;

  var filter = trigger.filter || {};
  var codeActionContext = {
    only: (_a = filter.include) === null || _a === void 0 ? void 0 : _a.value,
    trigger: trigger.type
  };
  var cts = new TextModelCancellationTokenSource(model, token);
  var providers = getCodeActionProviders(model, filter);
  var disposables = new DisposableStore();
  var promises = providers.map(function (provider) {
    return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var providedCodeActions, filteredActions, documentation;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              progress.report(provider);
              _context.next = 4;
              return provider.provideCodeActions(model, rangeOrSelection, codeActionContext, cts.token);

            case 4:
              providedCodeActions = _context.sent;

              if (providedCodeActions) {
                disposables.add(providedCodeActions);
              }

              if (!cts.token.isCancellationRequested) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", emptyCodeActionsResponse);

            case 8:
              filteredActions = ((providedCodeActions === null || providedCodeActions === void 0 ? void 0 : providedCodeActions.actions) || []).filter(function (action) {
                return action && filtersAction(filter, action);
              });
              documentation = getDocumentation(provider, filteredActions, filter.include);
              return _context.abrupt("return", {
                actions: filteredActions,
                documentation: documentation
              });

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](0);

              if (!isPromiseCanceledError(_context.t0)) {
                _context.next = 17;
                break;
              }

              throw _context.t0;

            case 17:
              onUnexpectedExternalError(_context.t0);
              return _context.abrupt("return", emptyCodeActionsResponse);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 13]]);
    }));
  });
  var listener = modes.CodeActionProviderRegistry.onDidChange(function () {
    var newProviders = modes.CodeActionProviderRegistry.all(model);

    if (!equals(newProviders, providers)) {
      cts.cancel();
    }
  });
  return Promise.all(promises).then(function (actions) {
    var allActions = flatten(actions.map(function (x) {
      return x.actions;
    }));
    var allDocumentation = coalesce(actions.map(function (x) {
      return x.documentation;
    }));
    return new ManagedCodeActionSet(allActions, allDocumentation, disposables);
  }).finally(function () {
    listener.dispose();
    cts.dispose();
  });
}

function getCodeActionProviders(model, filter) {
  return modes.CodeActionProviderRegistry.all(model) // Don't include providers that we know will not return code actions of interest
  .filter(function (provider) {
    if (!provider.providedCodeActionKinds) {
      // We don't know what type of actions this provider will return.
      return true;
    }

    return provider.providedCodeActionKinds.some(function (kind) {
      return mayIncludeActionsOfKind(filter, new CodeActionKind(kind));
    });
  });
}

function getDocumentation(provider, providedCodeActions, only) {
  if (!provider.documentation) {
    return undefined;
  }

  var documentation = provider.documentation.map(function (entry) {
    return {
      kind: new CodeActionKind(entry.kind),
      command: entry.command
    };
  });

  if (only) {
    var currentBest;

    var _iterator = _createForOfIteratorHelper(documentation),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var entry = _step.value;

        if (entry.kind.contains(only)) {
          if (!currentBest) {
            currentBest = entry;
          } else {
            // Take best match
            if (currentBest.kind.contains(entry.kind)) {
              currentBest = entry;
            }
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    if (currentBest) {
      return currentBest === null || currentBest === void 0 ? void 0 : currentBest.command;
    }
  } // Otherwise, check to see if any of the provided actions match.


  var _iterator2 = _createForOfIteratorHelper(providedCodeActions),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var action = _step2.value;

      if (!action.kind) {
        continue;
      }

      var _iterator3 = _createForOfIteratorHelper(documentation),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _entry = _step3.value;

          if (_entry.kind.contains(new CodeActionKind(action.kind))) {
            return _entry.command;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return undefined;
}

registerLanguageCommand('_executeCodeActionProvider', function (accessor, args) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var resource, rangeOrSelection, kind, model, validatedRangeOrSelection, codeActionSet;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            resource = args.resource, rangeOrSelection = args.rangeOrSelection, kind = args.kind;

            if (resource instanceof URI) {
              _context2.next = 3;
              break;
            }

            throw illegalArgument();

          case 3:
            model = accessor.get(IModelService).getModel(resource);

            if (model) {
              _context2.next = 6;
              break;
            }

            throw illegalArgument();

          case 6:
            validatedRangeOrSelection = Selection.isISelection(rangeOrSelection) ? Selection.liftSelection(rangeOrSelection) : Range.isIRange(rangeOrSelection) ? model.validateRange(rangeOrSelection) : undefined;

            if (validatedRangeOrSelection) {
              _context2.next = 9;
              break;
            }

            throw illegalArgument();

          case 9:
            _context2.next = 11;
            return getCodeActions(model, validatedRangeOrSelection, {
              type: 2
              /* Manual */
              ,
              filter: {
                includeSourceActions: true,
                include: kind && kind.value ? new CodeActionKind(kind.value) : undefined
              }
            }, Progress.None, CancellationToken.None);

          case 11:
            codeActionSet = _context2.sent;
            setTimeout(function () {
              return codeActionSet.dispose();
            }, 100);
            return _context2.abrupt("return", codeActionSet.validActions);

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
});